import { Maybe } from 'types/graphqlTypes'
import { ICarrierOptionDetailsFragment } from '../../../graphql/CarrierOptionDetailsFragment'

export const getDispatcherEmailSubject = (
  shipment: Maybe<ICarrierOptionDetailsFragment['shipment']>
): Maybe<string> => {
  if (!shipment) {
    return null
  }

  const { firstPickup, id: shipmentId, lastDelivery } = shipment || {}
  const { city: puCity, stateCode: puState } = firstPickup || {}
  const { city: delCity, stateCode: delState } = lastDelivery || {}

  const pickup = puCity && puState ? `${puCity}, ${puState}` : null
  const delivery = delCity && delState ? `${delCity}, ${delState}` : null
  const lane = pickup && delivery ? `${pickup} -> ${delivery}` : null

  return `${shipmentId ? `Load%20%23${shipmentId}` : ''}${lane ? `%20-%20Lane%20${lane}` : ''}`
}
